
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/the-only-symitar-quest-overlay",
      function () {
        return require("private-next-pages/blog/the-only-symitar-quest-overlay/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/the-only-symitar-quest-overlay"])
      });
    }
  